import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { listPosts } from "../api";
import Header from "./Header";
import Footer from "./Footer";

export default function BlogList() {
  const [posts, setPosts] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    listPosts()
      .then((data) => setPosts(data.filter((p) => p.published)))
      .catch(() => setPosts([]))
      .finally(() => setLoading(false));
  }, []);

  return (
    <div className="min-h-screen flex flex-col">
      {/* Hero-style header area */}
      <div className="bg-primary-animated relative">
        <Header />
        <div className="pt-32 pb-16 px-6 text-center">
          <h1 className="text-4xl md:text-5xl font-black text-white">Blog</h1>
          <p className="mt-4 text-gray-300 max-w-xl mx-auto">
            Insights on technology, data, music industry and software engineering.
          </p>
        </div>
      </div>

      {/* Posts */}
      <main className="flex-1 max-w-screen-lg mx-auto w-full py-12 px-6">
        {loading ? (
          <p className="text-gray-500 text-center">Loading posts...</p>
        ) : posts.length === 0 ? (
          <p className="text-gray-500 text-center">No posts yet. Check back soon!</p>
        ) : (
          <div className="grid gap-8 md:grid-cols-2 lg:grid-cols-3">
            {posts.map((post) => (
              <Link
                key={post.slug}
                to={`/blog/${post.slug}`}
                className="block border border-gray-200 rounded-lg p-6 hover:shadow-lg transition group"
              >
                <p className="text-xs text-gray-400 uppercase tracking-wide">
                  {new Date(post.date).toLocaleDateString("en-AU", {
                    year: "numeric",
                    month: "long",
                    day: "numeric",
                  })}
                </p>
                <h2 className="mt-2 text-xl font-bold text-gray-900 group-hover:text-primary-500 transition">
                  {post.title}
                </h2>
                {post.excerpt && <p className="mt-2 text-gray-600 text-sm leading-relaxed">{post.excerpt}</p>}
              </Link>
            ))}
          </div>
        )}
      </main>

      <Footer />
    </div>
  );
}
